import { OffersArticleOptionsComponent } from './offers-article-options.component';

import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ OffersArticleOptions: OffersArticleOptionsComponent });
